import React from 'react';
import NumberTypePage from './NumberTypePage';

const TollFreeNumbers = () => <NumberTypePage type="tollfree" />;

export default TollFreeNumbers;
